import { observer } from 'mobx-react-lite'
import { type Observable } from 'rxjs'
import { DocumentRequestsContainer } from '@/features/documents/components/DocumentRequests/DocumentRequestsContainer'
import { type DocumentsQuestionAnswerEditorViewModel } from '@/features/jobs/questions/documents/DocumentsQuestionAnswerEditorViewModel'
import { DocumentsQuestionAnswerEditor } from '@/features/jobs/questions/documents/components/DocumentsQuestionAnswerEditor'

export interface DocumentsQuestionAnswerEditorContainerProps {
  editorVm: DocumentsQuestionAnswerEditorViewModel
  isDisabled: boolean
  focus$?: Observable<unknown>
  onFocus?: () => unknown
}

export const DocumentsQuestionAnswerEditorContainer = observer(
  function DocumentsQuestionAnswerEditorContainer({
    editorVm,
    ...rest
  }: DocumentsQuestionAnswerEditorContainerProps) {
    return (
      <DocumentsQuestionAnswerEditor
        documentRequests={
          <DocumentRequestsContainer vm={editorVm.documentRequests} {...rest} />
        }
      />
    )
  },
)
